module.exports = __webpack_public_path__ + "img/E-WEB-Goal-6.553fdba9.png";